import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "calls-and-transcripts",
  courseId: "investigations",
  order: 5,
  title: "Calls",
  subtitle: "Transcripts and speaker names",
  summary:
    "The Calls tab is where you check the AI against the evidence itself. Each call has a relevance score, a summary, a click-to-seek transcript, and speakers you can name. Translated calls show both languages.",
  learn: [
    "Open a call and read it with the audio",
    "Name speakers so leads and the Brief use real names",
    "Export one or many transcripts",
  ],
  minutes: 3,
  releasedAt: "2026-08-24T00:00:00.000Z",
  gate: "investigations",
  body: [
    {
      type: "paragraph",
      text: "Every call carries the AI relevance score and summary, but the transcript and audio are always one click away so you can verify the source before you rely on a score.",
    },
    {
      type: "steps",
      items: [
        "Open the Calls tab. Calls are listed with their relevance score and summary. Sort to put the most relevant first.",
        "Open a call and click any transcript line to seek the audio to it.",
        "Name the speakers (inmate, called party).",
        "Add Notes on the call for your own observations.",
        "To export, use Export transcript on the call, or **Export** then Transcripts in the header to pick several calls and download one file or a ZIP.",
      ],
    },
    {
      type: "paragraph",
      text: "Leads in the call are highlighted in the transcript and listed in the rail, and the two highlight each other on hover. Names you set for speakers are kept through every later upload and rollup, so the Brief and the leads use them from then on.",
    },
    {
      type: "callout",
      tone: "note",
      title: "Translated calls",
      text: "Translated calls keep the original-language transcript alongside the English. Quotes in leads come from the English. The original is there for verification.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "Who is speaking",
      text: "Stereo recordings are split by channel, so the inmate and the called party are always separated. Mono recordings are separated by voice, up to four speakers.",
    },
    {
      type: "paragraph",
      text: "Next, Leads queue shows how to triage what the AI flagged in these calls.",
    },
  ],
  related: ["work-the-leads-queue", "bulk-upload-jail-calls", "ask-the-investigation"],
};

export default lesson;
